import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Image, ResponsiveContext, Stack, Text } from "grommet";
import { first, orderBy, take } from "lodash";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TeamName } from "../teams/TeamName";
import { getSeedMatch, SeedMatchParticipantViewModel, SeedMatchViewModel } from "./SeedMatchesStore";
import Avatar from "react-avatar";

export const SeedMatchRowWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [seedMatch, setSeedMatch] = React.useState(new SeedMatchViewModel());

    React.useEffect(() => {
        getSeedMatch(id).then((seedMatch) => {
            setSeedMatch(seedMatch);
            console.log("interactive");
        });
    }, []);

    return <SeedMatchRow seedMatch={seedMatch}></SeedMatchRow>;
};

export const SeedMatchRow = ({ seedMatch }: { seedMatch: SeedMatchViewModel }) => {
    let [teamOne, teamTwo] = seedMatch.participants as SeedMatchParticipantViewModel[];

    let navigate = useNavigate();

    const size = React.useContext(ResponsiveContext);

    return (
        <Box background={"background"} pad="medium" hoverIndicator="background-back" onClick={() => navigate("/seedMatches/" + seedMatch.id)}>
            <Grid columns={["1/4", "3/4"]}>
                <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                    {seedMatch.name}
                </Text>
                <Box direction="row" justify="evenly">
                    {take(seedMatch.participants, 4).map((participant) => (
                        <Box direction="row" key={participant.team.id} align="center" gap="small">
                            <Box align="center">
                                <Avatar name={participant.team.name} round={"18px"} size="35" src={participant.team.logoUri}></Avatar>
                                <Text>{participant.team.name}</Text>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Grid>
            <Box align="end">{seedMatch.participants && <Text size="small">{seedMatch.participants?.length} participants</Text>}</Box>
        </Box>
    );
};
